import { render, staticRenderFns } from "./letter-template.vue?vue&type=template&id=465f9338&scoped=true"
import script from "./letter-template.vue?vue&type=script&lang=ts"
export * from "./letter-template.vue?vue&type=script&lang=ts"
import style0 from "./letter-template.vue?vue&type=style&index=0&id=465f9338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f9338",
  null
  
)

export default component.exports